module.exports = __webpack_public_path__ + "static/media/mahakal.506ee8c6.webp";